// extracted by mini-css-extract-plugin
module.exports = {"p1fq87dq":"p1fq87dq","pksdwzw":"pksdwzw","puhxeay":"puhxeay","p10qe7zq":"p10qe7zq"};